import { toast } from '@kalos/ui';
import { createFileRoute, redirect } from '@tanstack/react-router';

import { AccountsOverview } from '../modules/AccountsOverview/AccountsOverview';
import { customerAccountAdminCheck } from '../tools/permissionChecks';

export const Route = createFileRoute('/accounts')({
  component: AccountsOverview,
  loader(ctx) {
    const permissionCheck = customerAccountAdminCheck(ctx.context.authContext.user);
    if (!permissionCheck) {
      toast({
        title: 'Access Denied',
        description:
          'You do not have permission to access the Accounts Overview. Please contact your administrator if you believe this is an error.',
        variant: 'destructive',
      });
      throw redirect({ to: '/' });
    }
  },
  head() {
    return {
      meta: [{ title: 'Accounts Overview' }],
    };
  },
});
